/// <reference path="../.tmp/typings/tsd.d.ts" />
"use strict";
var modal_directive_1 = require("./components/base/modal.directive");
var modal_service_1 = require("./components/base/modal.service");
var currentlyopenmodals_service_1 = require("./components/base/currentlyopenmodals.service");
var modalbody_directive_1 = require("./components/base/modalbody.directive");
var alert_directive_1 = require("./components/alert/alert.directive");
var loadingmodal_directive_1 = require("./components/loadingmodal/loadingmodal.directive");
var passwordprompt_directive_1 = require("./components/passwordprompt/passwordprompt.directive");
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('hmyModal', ['ngLodash', 'ngAnimate', 'hmyApi', 'hmyUiAssets'])
    .directive('hmyModal', modal_directive_1.default)
    .service('modalService', modal_service_1.default)
    .directive('body', modalbody_directive_1.default)
    .service('currentlyOpenModals', currentlyopenmodals_service_1.default)
    .directive('hmyAlert', alert_directive_1.default)
    .directive('hmyLoadingModal', loadingmodal_directive_1.default)
    .directive('hmyPasswordPrompt', passwordprompt_directive_1.default);



//////////////////
// WEBPACK FOOTER
// ./src/modals.module.ts
// module id = 1
// module chunks = 0